export default __webpack_public_path__ + "assembly122ed104.png";